// extracted by mini-css-extract-plugin
export default {"hideTooltip":"I--z","fadeIn":"J--z","delay":"K--z","recommendedSizeTooltip":"L--z"};